const SAVE_SUMMARY = 'SAVE_SUMMARY';

export default {
    SAVE_SUMMARY
};
